const PHONE_CODE_PREFIX = "+";

export const RU_PHONE_CODE = "7";
export const RU_PHONE_CODE_INTERNAL = "8";
export const DEFAULT_PLACEHOLDER = "+7 (___) ___-__-__";
export const PHONE_NUMBER_CARET_POSITION = 4;
export const MAX_PHONE_LENGTH = 11;
export const MIN_LENGTH_WITH_ONE_DIGIT = 2;

export const PHONE_MASK = [
  PHONE_CODE_PREFIX,
  RegExp(RU_PHONE_CODE),
  " ",
  "(",
  /\d/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
];
